interface ReadmailProps {
  className?: string;
  width?: string;
  height?: string;
}

function Readmail(props:Readonly<ReadmailProps>) {
  const { className, width, height } = props;
  const cssClassName = className ?? "";
  const cssWidth = width ?? "14";
  const cssHeight = height ?? "14";
  return (
    <span className="anticon">
      <svg
        width={cssWidth}
        height={cssHeight}
        className={cssClassName}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.7 23H15.3C20.8 23 23 20.8 23 15.3V8.7C23 3.2 20.8 1 15.3 1H8.7C3.2 1 1 3.2 1 8.7V15.3C1 20.8 3.2 23 8.7 23Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 13.1H5.136C5.972 13.1 6.731 13.573 7.105 14.321L8.084 16.29C8.7 17.5 9.8 17.5 10.064 17.5H13.947C14.783 17.5 15.542 17.027 15.916 16.279L16.895 14.31C17.269 13.562 18.028 13.089 18.864 13.089H22.978"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1738 6.5H13.8368"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 9.80005H14.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export default Readmail;
